module.exports = __webpack_public_path__ + "img/ethvm-logo.63fe6bb4.svg";